module.exports = __webpack_public_path__ + "static/img/pa.671c979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/pa.png
// module id = xMNH
// module chunks = 0